module.exports = __webpack_public_path__ + "static/media/SUN_SHIRT.28ea018f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/items/SUN_SHIRT.png
// module id = 102
// module chunks = 48